<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title> {{ getTitle() }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <table class="table_class">
      <tr>
        <mat-label class="boldLabel">Team Name</mat-label>
      </tr>
      <tr>
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input #first [(ngModel)]="inspectorsTeam.name" matInput />
        </mat-form-field>
      </tr>
      <tr>
        <mat-label class="boldLabel">Team Members</mat-label>
      </tr>
      <tr>
        <div class="members" #membersScroll>
          @for (member of inspectorsTeam.members; track member; let i = $index) {
            <div
              class="member"
              >
              <tr>
                <mat-form-field>
                  <mat-icon class="member-icon" matPrefix inline="true">
                    person
                  </mat-icon>
                  <input
                    [matAutocomplete]="auto"
                    [formControl]="controls[i]"
                    (input)="onInputChanged($event.target.value)"
                    type="text"
                    placeholder="Member"
                    matInput
                    />
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      [displayWith]="displayFn"
                      (optionSelected)="onInspectorSelected($event.option.value, i)"
                      >
                      @for (inspector of inspectors; track inspector) {
                        <mat-option
                          [value]="inspector"
                          >
                          {{ inspector.name }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <mat-icon (click)="removeInspector(member, i)" matSuffix>
                      close
                    </mat-icon>
                  </mat-form-field>
                </tr>
              </div>
            }
            <div>
              @if (validateUserFlag) {
                <tr class="error-Message">
                  Team Member Already Added.
                </tr>
              }
            </div>
          </div>
        </tr>
        <div>
          <button
            class="add-button"
            [disabled]="!allTeamMembersAreCorrect()"
            (click)="addAdditionalMember()"
            mat-button
            color="primary"
            >
            <mat-icon class="add-icon" inline="true">group_add</mat-icon>
            ADD MEMBER
          </button>
        </div>
      </table>
    </mat-card-content>

    <mat-card-actions align="end">
      <button (click)="cancel()" mat-button>CANCEL</button>
      <button
        [disabled]="!isFormReady()"
        (click)="save()"
        mat-button
        color="accent"
        >
        SAVE
      </button>
    </mat-card-actions>
  </mat-card>
